import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=deb6cdee&scoped=true"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=deb6cdee&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb6cdee",
  null
  
)

export default component.exports